<template>
  <div class="col-md-12 button">
    <button @click="onClick" :type="type" class="button-search" :style="'float:' + whichSide" :disabled="disabled">
      <span class="button-validate" v-if="haveLoading">
        <span v-if="!loading" class="button-label">{{ label }}</span>
        <div v-else class="loading-btn button-loading">
          <div class="spinner-btn button-spinner">
            <div class="rect1"></div>
            <div class="rect2"></div>
            <div class="rect3"></div>
            <div class="rect4"></div>
            <div class="rect5"></div>
          </div>
        </div>
      </span>
      <span class="button-validate" v-else>
        <span class="button-label">{{ label }}</span>
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: "btnSearch",
  props: {
    label: {
      required: true,
    },
    loading: {
      default: false,
    },
    haveLoading: {
      default: false,
    },
    whichSide: {
      default: 'left',
    },
    type: {
      default: ''
    },
    disabled: {
      default: false
    }
  },
  methods: {
    onClick() {
      this.$emit('emit-click')
    }
  }
}
</script>

<style lang="scss" scoped>

.button {

  &-search {
    border: none;
    border-radius: 4px !important;
    padding: 11px 46px;
    background: #2F23D6;
    transition: .2s;

    &:hover, &:active {
      background: #352DA5;
    }
  }

  &-search > &-validate > &-label {
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;
    color: #FFFFFF;
  }

  &-search > &-validate > &-loading > &-spinner {
    > div {
      margin-right: 1.8px !important;
      height: 20px !important;
    }

    .rect5 {
      margin-right: 0 !important;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/buttons/btnSearch.vue